import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { FooterContentProps } from '../rotate-drawer-types';
import styles from '../rotate-drawer.module.scss';

export const FooterContent = ({ onDrawerCancel, onDrawerApply }: FooterContentProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={styles['footer-wrapper']}>
      <Button
        testId="rotate-drawer--cancel"
        className={classNames(styles['footer-buttons'])}
        onClick={onDrawerCancel}
        variant="secondary"
      >
        {t('footerContent.cancel')}
      </Button>
      <Button
        testId="rotate-drawer--apply"
        className={classNames(styles['footer-buttons'])}
        onClick={onDrawerApply}
        variant="primary"
      >
        {t('footerContent.apply')}
      </Button>
    </div>
  );
};
